<template>
  <div class="game-board-container">
    <game-tile
      v-for="tile in sortedBoard"
      :key="tile.id"
      :hotel-id="tile.hotel"
      :is-child-hotel="tile.isChild"
      :tile-id="tile.id"
      :is-empty="tile.isEmpty"
      :my-tile="myTile(tile.id)"
      @click="onClickTile(tile.id)"
    />
  </div>
</template>

<script>
import { sortBy } from 'lodash';
import { mapGetters, mapActions } from 'vuex';
import {NS_GAME_STATE, NS_TURN_STATE} from "@/store/constants";
import GameTile from "@/components/board/GameTile";

export default {
  name: 'GameBoard',

  components: {
    GameTile,
  },

  computed: {
    ...mapGetters(NS_GAME_STATE, [
      'board',
      'localPlayer',
      'selectedTile',
      'localPlayerTiles',
    ]),

    sortedBoard() {
      return sortBy(this.board, [
        (tile) => {
          const column = tile.id.slice(0, 1);
          return column;
        },
        (tile) => {
          const row = tile.id.slice(1);
          return Number(row);
        }
      ]);
    },
  },

  methods: {
    ...mapActions(NS_TURN_STATE, [
      'flowPlaceTile',
    ]),

    myTile(tileId) {
      return this.localPlayerTiles.includes(tileId) && tileId !== this.selectedTile;
    },

    async onClickTile(tileId) {
      if (this.myTile(tileId)) {
        await this.flowPlaceTile(tileId);
        return;
      }
    }
  }
}
</script>

<style scoped>
.game-board-container {
  display: grid;
  grid-template-columns: repeat(12, 1fr [col-start]);
  grid-template-rows: repeat(9, 1fr [row-start]);
  column-gap: 1px;
  row-gap: 1px;
  max-width: 100vw;
  overflow-y: scroll;
}

@media screen and (min-width: 587px) {
  .game-board-container {
    margin: 15px auto;
    width: 587px;
    border: 2px solid #000000ad;
    border-radius: 3px;
    overflow-y: hidden;
  }
}

@media screen and (min-width: 1250px) {
  .game-board-container {
    margin: 0;
  }
}
</style>

